



import React, { useState } from "react";
import robotics from "../img/robotics hands working.mp4";
import { useNavigate } from 'react-router-dom';
const KeyFuturesSection = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        date: "",
        gender: "",
        message: "",
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };
const navigate = useNavigate();
    const goToCartPage = () => {
  navigate('/cart-page');
};
    const handleSubmit = async (e) => {
        e.preventDefault();
        const apiBody = {
            firstName: formData.name,
            emailId: formData.email,
            contactNumber: formData.phone,
            date: formData.date,
            gender: formData.gender,
            message: formData.message,
        };

        try {
            const response = await fetch(
                "http://10.10.20.9:7071/IIA-Website-1.0.0/contactus/contact",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(apiBody),
                }
            );

            if (response.ok) {
                alert("Your details have been submitted successfully!");
            } else {
                alert("There was an issue submitting your details.");
            }
        } catch (error) {
            alert("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="container mt-5">
            <div className="row d-flex align-items-start" style={{ marginTop: "00px" }}>
                {/* Content Section */}
                <div className="col-md-7">
                    <div className="p-4 bg-white shadow rounded mb-4" style={{ height: '319px', }}>
                        <h2 style={{ fontWeight: "bold", fontSize: '22px', }}>
                        Industry Insights on Flutter  {" "}
                            <span style={{ color: "#ffa500", fontWeight: "800" }}>Development

                            </span>
                        </h2>
                        <p style={{ paddingBottom: '45px', textAlign: 'justify',fontFamily:'roboto' }}>
                        Flutter, created by Google, is a powerful open-source framework for building natively compiled applications for mobile, web, and desktop from a single codebase. It's become a game-changer in the development world, offering a way to create beautiful, high-performance apps quickly and efficiently. With its growing popularity among top companies and developers, mastering Flutter is essential for staying ahead in the ever-evolving app development landscape.


                        </p>
                     <div
                                                    className="disccccreting"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'left',
                                                        gap: '20px',
                                                        marginTop: '-34px',
                                                        flexWrap: 'wrap', // Allows wrapping in smaller screens
                                                    }}
                                                >
                                                    {/* Rating Section */}
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flex: '1 1 auto' }}>
                                                        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>4.5</span>
                                                        <div style={{ display: 'flex', fontSize: '20px' }}>
                                                            {/* Yellow stars */}
                                                            <span style={{ color: '#FFD700' }}>★</span>
                                                            <span style={{ color: '#FFD700' }}>★</span>
                                                            <span style={{ color: '#FFD700' }}>★</span>
                                                            <span style={{ color: '#FFD700' }}>★</span>
                                                            {/* Partially filled star */}
                                                            <span style={{ color: '#FFD700', position: 'relative' }}>
                                                                <span
                                                                    style={{
                                                                        color: '#fff',
                                                                        position: 'absolute',
                                                                        left: '8px',
                                                                        overflow: 'hidden',
                                                                        width: '10px',
                                                                    }}
                                                                >
                                                                    ★
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                    
                                                    {/* Wishlist Button */}
                                                   <a
                                                href="/brochure.pdf" // Path to the file in the public folder
                                                download="brochure.pdf" // This triggers the download
                                                style={{
                                                    textDecoration: 'none',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                <button
                                                    style={{
                                                        padding: '10px 20px',
                                                        fontSize: '14px',
                                                        backgroundColor: '#007bff',
                                                        color: 'white',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        fontFamily: 'roboto',
                                                        fontWeight: 'bold',
                                                        cursor: 'pointer',
                                                        flex: '1 1 auto',
                                                        minWidth: '120px',
                                                    }}
                                                >
                                                    Brochure
                                                </button>
                                            </a>


                                            <button
                                                onClick={goToCartPage}
                                                style={{
                                                    padding: '10px 20px',
                                                    fontSize: '14px',
                                                    backgroundColor: '#007bff',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '5px',
                                                    fontFamily: 'roboto',
                                                    fontWeight: 'bold',
                                                    cursor: 'pointer',
                                                    flex: '1 1 auto',
                                                    minWidth: '120px',
                                                }}
                                            >
                                                Add to Cart
                                            </button>
                    
                                                    {/* Apply Now Button */}
                                                    <button
                                                        style={{
                                                            padding: '10px 20px',
                                                            fontSize: '14px',
                                                            backgroundColor: '#007bff',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            fontFamily: 'roboto',
                                                            fontWeight: 'bold',
                                                            cursor: 'pointer',
                                                            // width:'-3px',
                                                            flex: '1 1 auto', // Makes the button flexible in size
                                                        }}
                                                    >
                                                        Apply Now
                                                    </button>
                    
                                                    <style>
                                                        {`
                        @media (max-width: 768px) {
                          .disccccreting {
                            justify-content: center; /* Center-align items on smaller screens */
                            gap: 10px; /* Reduce gap for mobile view */
                          }
                    
                          .disccccreting button {
                            flex: 1 0 100%; /* Make buttons full-width */
                            text-align: center; /* Center button text */
                          }
                    
                          .disccccreting div {
                            flex: 1 0 100%; /* Ensure proper alignment for the rating section */
                            text-align: center; /* Center align rating */
                          }
                        }
                        `}
                                                    </style>
                                                </div>
                                            </div>
                    
                    
                                        
                                        {/* <h3 style={{ fontWeight: "bold", color: "rgb(34 64 153)",textAlign:'left', marginTop:'40px' }}>Key Features</h3>
                                        <div className="row">
                                            {[
                                                "Receive a prestigious certificate endorsed by IIA and I-Robotics, validating your expertise in tools and virtual robotics.",
                                                "Exclusive hackathons and Ask Me Anything sessions by IIA.",
                                                "Live sessions on the latest AI trends, such as generative AI, prompt engineering, explainable AI, and more.",
                                                "Capstone from 3 domains and 14+ Data Analytics Projects with Industry datasets.",
                                                "Master Classes delivered by Purdue faculty and IBM experts.",
                                                "We assist you to get noticed by top hiring companies.",
                                            ].map((feature, index) => (
                                                <div className="col-12 mb-3" key={index}>
                                                    <div
                                                        className="key-feature-box p-3 bg-white shadow rounded"
                                                        style={{ border: "1px solid grey" }}
                                                    >
                                                        <li style={{ listStyleType: "none", borderRadius: "50px" }}>
                                                            {feature}
                                                        </li>
                                                    </div>
                                                </div>
                                            ))}
                                        </div> */}
                                    </div>
                    
                                    {/* Form and Video Section */}
                                    <div className="col-md-5" style={{ borderRadius:'20px',}}>
                                        {/* Video */}
                                        <div style={{ marginBottom: "20px" }}>
                                            <video
                                                src={robotics}
                                                controls
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "10px",
                                                    height:'318px',
                                                    backgroundColor:'black',
                                                    borderRadius:'20px',
                                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                                                }}
                                            />
                                        </div>
                    {/* Form */}
                    {/* <div
                        style={{
                            width: "100%",
                            minHeight: "500px",
                            maxHeight: "90vh",
                            overflowY: "auto",
                            padding: "30px",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            marginTop:'100px',
                        }}
                     >
                        <h2 style={{ textAlign: "center" }}>Enquiry Form</h2>
                        <form
                            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
                            onSubmit={handleSubmit}
                        >
                            <input
                                type="text"
                                id="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    fontSize: "16px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <input
                                type="email"
                                id="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    fontSize: "16px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <input
                                type="tel"
                                id="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    fontSize: "16px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <input
                                type="date"
                                id="date"
                                value={formData.date}
                                onChange={handleChange}
                                required
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    fontSize: "16px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                            <select
                                id="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                required
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                            <textarea
                                id="message"
                                placeholder="Your Message"
                                rows="4"
                                value={formData.message}
                                onChange={handleChange}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    height:'50px'
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    padding: "12px",
                                    backgroundColor: "#495057",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                Submit
                            </button>
                        </form>
                    </div> */}
                </div>


            </div>
        </div>


    );
};

export default KeyFuturesSection;
